import React from "react";
import classes from './Popup.module.css'
const Popup = ({ feature }) => {
  const { id, name, address, organization, note, description } = feature.properties;

  return (
    <div id={`popup-${id}`} className={classes.Popup}>
      <h4>{name}</h4>
      {organization ? <p>{organization}</p> : null}
      <address>{address}</address>
      <p>{description}</p>
      {note ? <p>{note}</p> : null}
    </div>
  );
};

export default Popup;